import { NotificationTypes } from "@/enums/notifications";
import type { JobStatus } from "@/enums/jobs";
import { getIdToken } from "@/services/Auth";
import { getBaseApiUrl, getDefaultHeaders, request } from "@/utils/CreativeIntelligenceApi";
import { API_ROUTES } from "@/constants";

export async function createJob({
    body
}: {
    body: {
        type: (typeof NotificationTypes)[keyof typeof NotificationTypes];
        input: Record<string, unknown>;
    };
}) {
    const baseUrl = getBaseApiUrl();

    const url = `${baseUrl}${API_ROUTES.JOB}`;
    const token = await getIdToken();
    const headers = getDefaultHeaders(token);

    return request<{
        jobId: string;
        status: (typeof JobStatus)[keyof typeof JobStatus];
    }>(url, headers, "POST", body);
}
